import {
  createBaseThemeOptions,
  createUnifiedTheme,
  genPageTheme,
  palettes,
  shapes,
} from '@backstage/theme';

export const veluxTheme = createUnifiedTheme({
  ...createBaseThemeOptions({
    palette: {
      ...palettes.light,
      primary: {
        main: '#343b58',
      },
      secondary: {
        main: '#565a6e',
      },
      error: {
        main: '#8c4351',
      },
      warning: {
        main: '#8f5e15',
      },
      info: {
        main: '#34548a',
      },
      success: {
        main: '#485e30',
      },
      text: {
        primary: '#343b58',
      },
    },
    fontFamily: 'Frugtier, sans-serif',
    defaultPageTheme: 'home',
  }),
  components: {
    BackstageHeader: {
      styleOverrides: {
        header: ({ theme }) => ({
          backgroundImage: genPageTheme({
            colors: ['#0077C8', theme.palette.primary.main],
            shape: shapes.wave,
          }).backgroundImage,
        }),
      },
    },
    BackstageSidebar: {
      styleOverrides: {
        drawer: ({ theme }) => ({
          background: theme.palette.primary.main,
          indicator: theme.palette.primary.main,
          selectedColor: '#ffffff',
        }),
      },
    },
    BackstageSidebarItem: {
      styleOverrides: {
        root: ({ theme }) => ({
          color: theme.palette.background.default,
          textDecoration: 'none',
        }),
      },
    },
    BackstageSelectInputBase: {
      styleOverrides: {
        root: {
          'label + &': {
            marginTop: 0,
          },
        },
      },
    },
    MuiBadge: {
      styleOverrides: {
        dot: {
          backgroundColor: 'red',
        },
      },
    },
  },
});
